// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__2pNZn","success":"FinishedQuiz_success__ciGR1","error":"FinishedQuiz_error__Lf7Mt"};